"use client";
import Image from "next/image";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import ScheduleIcon from '@mui/icons-material/Schedule';

export function SearchBar({ handleSearch, recentSearches, placeholder = 'Search for Topics, Articles' }: { handleSearch: (searchText: string) => void, recentSearches: string[], placeholder?: string }) {
    const searchParams: any = useSearchParams();
    const [isWebView, setIsWebView] = useState(false);
    const [searchText, setSearchText] = useState('');
    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSearch(searchText);
            const searchBar = document.querySelector('.blog-search-bar');
            if (searchBar) {
                searchBar.classList.add('hidden');
            }
            (event.target as HTMLInputElement).blur();
        }
    };
    useEffect(() => {
        setSearchText(searchParams.get('search') ?? '');
    }, [searchParams])
    useEffect(() => {
    
        const userAgent = navigator.userAgent || '';
        const isAppWebView = /AppWebView/i.test(userAgent);
        setIsWebView(isAppWebView);
    
      }, [])

    return (
        <div className="relative">
            <div className={` search-bar-container border-2  rounded-2xl overflow-hidden p-2 flex  gap-4 justify-between ${isWebView ? 'bg-[#ede4dd] lg:bg-white' : 'bg-white'}`}>
                <input
                    type="text"
                    placeholder={placeholder}
                    className={` border-0 focus:outline-0 order  grow bg-transparent`}
                    onChange={(e) => setSearchText(e.target.value)}
                    value={searchText}
                    onKeyDown={handleKeyDown}
                    onBlur={() => {
                        const searchBar = document.querySelector('.blog-search-bar');
                        const searchBarContainer = document.querySelector('.search-bar-container');
                        if (searchBarContainer)
                            searchBarContainer.classList.remove('border-[#EE932280]');
                        if (searchBar)
                            searchBar.classList.add('hidden');

                    }}
                    onMouseDown={() => {
                        const searchBar = document.querySelector('.blog-search-bar');
                        const searchBarContainer = document.querySelector('.search-bar-container');
                        if (searchBarContainer)
                            searchBarContainer.classList.add('border-[#EE932280]');
                        if (searchBar && recentSearches.length) {
                            searchBar.classList.remove('hidden');
                        }
                    }}

                />
                <Image src={`./clear-search.svg`} width={24} height={24} alt="clear-search-button"
                    className={` ${searchParams.get('search') ? '' : 'hidden'}`}
                    onClick={() => {
                        handleSearch('');
                        setSearchText('');
                    }} />

            </div>
            <div className={`blog-search-bar absolute hidden bg-white border-2 rounded-xl p-4 w-full top-12 z-[500] grid gap-2 `}>
                {recentSearches.map((searchText, i) => {
                    return <div className=" flex gap-2 items-center cursor-pointer" key={`recent-search-${searchText}-${i}`} onMouseDown={(e) => {
                        handleSearch(searchText);
                        setSearchText(searchText);
                    }}>
                        <ScheduleIcon sx={{ 'width': '16px', 'height': '16px', 'opacity': '0.8' }} />
                        <p className="break-all">{searchText}</p>
                    </div>
                }
                )}
            </div>
        </div>
    );
}